











































import { Vue, Component, Prop, Emit, Ref } from "vue-property-decorator";
import { vxm } from "@/store";
import api from "@/plugins/api";

@Component({})
export default class SignInDialog extends Vue {
  @Prop() value!: boolean;
  @Ref("form") form: any;

  valid = false;
  loading = false;

  email = "";
  password = "";
  emailRules = [(v: string) => !!v || "Please enter your email or username"];
  passwordRules = [(v: string) => !!v || "Please enter your password"];
  emailErrors: string[] = [];
  passwordErrors: string[] = [];

  @Emit("input")
  close() {
    return false;
  }

  async submit() {
    this.emailErrors = [];
    this.passwordErrors = [];

    await this.form.validate();

    if (!this.valid) {
      return;
    }

    try {
      this.loading = true;
      const { data } = await api.post("v3/auth/token", {
        email: this.email,
        password: this.password
      });

      vxm.auth.setAccessToken(data.accessToken);
      vxm.auth.setUser(data.profile.user);

      this.form.reset();
      this.close();
    } catch ({
      response: {
        data: { error_code }
      }
    }) {
      console.log(error_code);

      switch (error_code) {
        case "username_or_email_missing":
        case "user_not_found":
          this.emailErrors = ["User not found"];
          break;
        case "password_missing":
        case "incorrect_password":
          this.passwordErrors = ["Incorrect password"];
          break;
      }
    } finally {
      this.loading = false;
    }
  }
}
